import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toastMessage } from "../utils/toastMessage";

// this code is created an instance with base url for admin
export const instance = axios.create({
  // baseURL: 'http://192.168.1.60:8000/api/',
  // baseURL: 'http://localhost:8001/api/', 
  baseURL: 'https://adminapi.vedicmeet.com/api/',
  // baseURL: 'http://localhost:5000/api/',
  // baseURL: 'https://7bd349b5aa81.ngrok-free.app/api/',
  // baseURL:'https://adminapi.vedicmeet.com/api/'
  // baseURL:'https://adminapi.vedicmeet.com/api/'
});



export const markUsedForQueryApi = (payload) => {
  return instance.post('used-for-query', payload, setJwtToken());
  
};

export const setJwtToken = () => {
  const token = localStorage.getItem("vedic_token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
};

export const setMultiPartHeader = () => {
  const token = localStorage.getItem("vedic_token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };
};

// this interceptors checks user's token is valid or not
export const AxiosInterceptor = ({ children }) => {
  const [isSet, setIsSet] = useState(false);
  const navigate = useNavigate();

  const removeToken = () => {
    localStorage.removeItem("vedic_token");
    localStorage.removeItem("vedic_role");
    localStorage.removeItem("vedic_rights");
  };

  useEffect(() => {
    const resInterceptor = (response) => {
      console.log(response,"Response");
      const skipAuthLogout = response?.config?.skipAuthLogout === true;
      if (response?.data?.code === 401 && !skipAuthLogout) {
        removeToken();
        navigate("/");
      }
      return response;
    };

    const errInterceptor = (error) => {
      // console.log(error,"Error");
      if (error?.message === "Network Error") {
        toastMessage(error?.message, "error", "networkError");
        return Promise.reject(error);
      }

      // Handle 401 Unauthorized - Token expired or invalid
      const skipAuthLogout = error?.config?.skipAuthLogout === true;
      if (!skipAuthLogout && (error?.response?.status === 401 || error?.response?.data?.code === 401)) {
        removeToken();
        toastMessage("Session expired. Please login again.", "error", "unauthorized");
        navigate("/");
        return Promise.reject(error);
      }

      if (error?.response?.data?.code === 404) {
        removeToken();
        navigate("/");
        return Promise.reject(error);
      }

      if (error.response && error.response?.data?.code === 400) {
        toastMessage(error.response?.data?.message, "error", "errorMeesage");
      }

      return Promise.reject(error);
    };

    const interceptor = instance.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );
    setIsSet(true);

    return () => instance.interceptors.response.eject(interceptor);
    // eslint-disable-next-line
  }, []);

  return isSet && children;
};
// 